import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import env from '#env';

export const useSentry = () => {
    const enableSentry = Boolean(env.VITE_SENTRY) && Boolean(env.VITE_SENTRY_DSN);

    if (enableSentry) {
        Sentry.init({
            dsn: env.VITE_SENTRY_DSN,
            integrations: [
                new Sentry.BrowserTracing({
                    routingInstrumentation: Sentry.reactRouterV6Instrumentation(
                        useEffect,
                        useLocation,
                        useNavigationType,
                        createRoutesFromChildren,
                        matchRoutes
                    ),
                }),
            ],
            tracesSampleRate: env.VITE_SENTRY_SAMPLE_RATE,
            replaysSessionSampleRate: env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
            replaysOnErrorSampleRate: env.VITE_REPLAYS_ON_ERROR_SAMPLE_RATE,
        });
    }
};
